import { ProductsSelections } from '../../../store/features/packages/types';

export function hasProductsInFormValues(formValues: ProductsSelections) {
  const { productMultipleIds, productSingleIdsMap } = formValues;

  return (
    productMultipleIds.length > 0 || Object.keys(productSingleIdsMap).length > 0
  );
}
